import { Content, DefaultComponentProps } from '@measured/puck';

type Block = {
  type?: string;
  props?: {
    anchor?: string;
    tabs?: Array<{ slug?: string; content?: unknown[] }>;
    [key: string]: unknown;
  };
  [key: string]: unknown;
};

const getAllAnchors = (content: Content<DefaultComponentProps>): string[] => {
  const anchors: Set<string> = new Set<string>();

  const addAnchor = (props?: { anchor?: string }, tabSlug?: string | null) => {
    if (props?.anchor) {
      anchors.add(tabSlug ? `${tabSlug}#${props.anchor}` : props.anchor);
    }
  };

  const handleTabs = (tabs?: Array<{ slug?: string; content?: unknown[] }>) => {
    tabs?.forEach((tab) => {
      if (tab?.slug && Array.isArray(tab.content)) {
        tab.content.forEach((item) => search(item as Block, tab.slug));
      }
    });
  };

  const deepSearch = (value: unknown, tabSlug: string | null = null) => {
    if (!value || typeof value !== 'object') return;
    if (Array.isArray(value)) {
      value.forEach((item) => deepSearch(item, tabSlug));
      return;
    }

    addAnchor((value as Block).props, tabSlug);

    if ((value as Block).type === 'ReportTabsBlock') {
      handleTabs((value as Block).props?.tabs);
      return;
    }
    Object.entries(value as Record<string, unknown>).forEach(([key, val]) => {
      deepSearch(val, tabSlug);
    });
  };

  const search = (current: Block, tabSlug: string | null = null) => {
    deepSearch(current, tabSlug);
  };

  search(content as unknown as Block);
  return Array.from(anchors).sort((a, b) => a.localeCompare(b));
};

export { getAllAnchors };
